import { useContext } from "react";
import { MerchantDetailTabContext } from "./MerchantDetailTab";
import type { IDomainRepository } from "hooks/useDomainState";

export default function useMerchantDetailsTabContext<TRepository extends IDomainRepository>() {
    return useContext(MerchantDetailTabContext) as TRepository;
};
